import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { resolveIsAdmin } from "@/lib/adminRole";

interface IsAdminState {
  isAdmin: boolean;
  loading: boolean;
}

/**
 * Indica si la sesión actual pertenece a un Super Admin de Plaxter.
 * Resuelve en servidor (RPC `is_user_admin`) y nunca cachea en storage.
 */
export function useIsAdmin(): IsAdminState {
  const { user, loading: authLoading } = useAuth();
  const [state, setState] = useState<IsAdminState>({ isAdmin: false, loading: true });

  useEffect(() => {
    let cancelled = false;

    if (authLoading) {
      setState((prev) => (prev.loading ? prev : { ...prev, loading: true }));
      return () => {
        cancelled = true;
      };
    }

    if (!user) {
      setState({ isAdmin: false, loading: false });
      return () => {
        cancelled = true;
      };
    }

    setState((prev) => (prev.loading ? prev : { ...prev, loading: true }));
    resolveIsAdmin(user.id).then((isAdmin) => {
      if (!cancelled) setState({ isAdmin, loading: false });
    });

    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  return state;
}
